module.exports = __webpack_public_path__ + "img/tg_swper03.a3094bd0.png";